import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Loader2, AlertCircle, ShieldCheck } from 'lucide-react';
import axios from 'axios';
import { useLoneStarAuth } from '@/context/LoneStarAuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Manual fallback sign-in for the Lone Star cross-brand bridge.
 * The primary entry point is the one-click "Open Lone Star Dashboard"
 * switch from the Amigos dashboard (SSO code exchange) — this page
 * exists for direct/bookmarked access or when a session has expired.
 */
const LoneStarLogin = () => {
  const { setSession } = useLoneStarAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      const res = await axios.post(`${API}/lonestar/auth/login`, { email, password });
      setSession(res.data.access_token, res.data.user);
      navigate('/lonestar/overview');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Invalid email or password');
    } finally { setBusy(false); }
  };

  return (
    <div className="amigos-app dash-body">
      <div className="dash-login" data-testid="lonestar-login">
        <div className="dash-login__card">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.6rem' }}>
            <ShieldCheck size={22} color="var(--gold)" />
            <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', color: 'var(--text-primary)' }}>LONE STAR BONDING</span>
          </div>
          <div className="eyebrow text-center">CROSS-BRAND BRIDGE</div>
          <h1 className="section-title text-center" style={{ fontSize: '1.4rem', marginBottom: '1.6rem' }}>SIGN IN</h1>
          <form onSubmit={submit}>
            <div className="form-field">
              <label className="form-label" htmlFor="ls-login-email">Email</label>
              <input id="ls-login-email" type="email" required className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="lonestar-login-email-input" />
            </div>
            <div className="form-field">
              <label className="form-label" htmlFor="ls-login-password">Password</label>
              <input id="ls-login-password" type="password" required className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="lonestar-login-password-input" />
            </div>
            {error && <div className="form-error mb-4" style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}><AlertCircle size={15} /> {error}</div>}
            <button type="submit" className="btn-red" disabled={busy} style={{ width: '100%', justifyContent: 'center' }} data-testid="lonestar-login-submit-btn">
              {busy ? <Loader2 size={16} className="spinner" style={{ border: 'none' }} /> : 'Sign In'}
            </button>
          </form>
          <p style={{ textAlign: 'center', fontSize: '0.78rem', color: 'var(--text-dim)', marginTop: '1.2rem' }}>
            {'Amigos staff: use "Open Lone Star Dashboard" from your '}
            <Link to="/dashboard/login" style={{ color: 'var(--gold)' }}>Amigos dashboard</Link>
            {' menu instead — no separate login required.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoneStarLogin;
